export default __webpack_public_path__ + "images/MisB2B.svg";